import { Injectable } from '@angular/core';
import { SessionService } from '@edl-development/edl-common';
import { LocalStorageKeys } from '../../model/enum/local-storage-keys.enum';
import { ObservationTypeValues } from '../../model/enum/observation-type-values.enum';
import { PAETEPRoleType } from '../../model/enum/paetep-role-types.enum';
import { PermissionTypes } from '../../model/enum/permission-types.enum';
import { UserSummaryPermissions } from '../../model/observation/user-summary-permisions.model';
import { BuildingToRolePermission } from '../../model/permissions/building-to-role-permission-dto.model';
import { SessionHelpersService } from '../session-helpers-service/session-helpers.service';

@Injectable()
export class PermissionsHelperService {

    constructor(private sessionService: SessionService, private sessionHelpersService: SessionHelpersService) { }

    doIHaveAllPermissions = (permissions: PermissionTypes[]) => {
        const myPermissions = this.getMyPermissions();
        return permissions.every(permission => myPermissions[permission]);
    }

    doIHaveAnyPermissions = (permissions: PermissionTypes[]) => {
        const myPermissions = this.getMyPermissions();
        return permissions.length == 0 || permissions.some(permission => myPermissions[permission]);
    }

    doIHaveBuildings = () => {
        return this.sessionHelpersService.getBuildings().length > 0;
    }

    canIManageRole = (roleType: PAETEPRoleType) => {
        const rolesICanManage = this.getRolesICanManage();

        return this.canIManageRole_Internal(rolesICanManage, roleType);
    }

    canIManageRoleForBuilding = (buildingId: number, roleType: PAETEPRoleType) => {
        const rolesICanManagePerBuilding = this.getRolesICanManagePerBuilding();

        return this.canIManageRole_Internal(rolesICanManagePerBuilding[buildingId] ?? [], roleType);
    }

    private canIManageRole_Internal = (rolesICanManage: PAETEPRoleType[], roleType: PAETEPRoleType) => {
        return rolesICanManage.findIndex(r => r === roleType) !== -1;
    }

    canCreateObservation = (observationTypeValues: ObservationTypeValues[] = [], userSummaryPermissions?: UserSummaryPermissions) => {
        return (userSummaryPermissions?.canCreateObservation ?? []).reduce((canCreate: boolean, currentValue) => {
            return canCreate || observationTypeValues.includes(currentValue);
        }, false)
    }

    private getMyPermissions = () => {
        return <{ [key: string]: boolean }>(this.sessionService.GetSessionValue(LocalStorageKeys.PERMISSIONS) ?? {} as { [key: string]: boolean });
    }

    private getRolesICanManage = (): PAETEPRoleType[] => {
        return <PAETEPRoleType[]>(this.sessionService.GetSessionValue(LocalStorageKeys.ROLES_I_CAN_MANAGE) ?? {});
    }

    private getRolesICanManagePerBuilding = (): BuildingToRolePermission => {
        return <BuildingToRolePermission>(this.sessionService.GetSessionValue(LocalStorageKeys.ROLES_I_CAN_MANAGE_PER_BUILDING) ?? {});

    }
}